import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';

interface Props {
  isLoading: boolean;
}

export const CheckoutFraudsterWarning = ({ isLoading }: Props) => {
  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
        <CheckoutSectionTitle>Last Minute Booking Notice</CheckoutSectionTitle>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading}>
        <Typography variant="body1">
          Your stay has an arrival date of 7 days or less,
          which may have additional security checks on your
          arrival before accessing the property.
          Please ensure to bring your government issued
          identification that matches your alluraDirect account
          as well as the physical credit card that matches this charge.
        </Typography>
      </LoadingSkeleton>
    </Grid>
  );
};
